import { ChangeDetectionStrategy, Component, OnInit, WritableSignal, inject, signal } from '@angular/core';
import { asapScheduler } from 'rxjs';
import { observeOn } from 'rxjs/operators';
import { MatProgressBar } from '@angular/material/progress-bar';
import { BusyService } from '../core/busy.service';

@Component({
    selector: 'app-busy',
    templateUrl: './busy.component.html',
    styleUrls: ['./busy.component.scss'],
    imports: [MatProgressBar],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BusyComponent implements OnInit {
  private busyService = inject(BusyService);

  busy: WritableSignal<boolean> = signal(false);

  ngOnInit(): void {
      this.busyService.busyState$.pipe(observeOn(asapScheduler))
      .subscribe(state => this.busy.set(state.isBusy));
  }

}
